import React from "react";
import SeriesListPage from "../catalogue/SeriesListPage";
import { deleteShow, getShowList } from "../../../services/shows";

const ShowList = () => (
  <SeriesListPage
    fetchItems={() => getShowList().then((result) => result?.allTvShows)}
    deleteItem={deleteShow}
    emptyIcon="ri-tv-2-line"
    paths={{
      add: "/dashboard/add-show",
      view: (id) => `/dashboard/show-info/${id}`,
      episodes: (id) => `/dashboard/episode-list/${id}`,
      edit: (id) => `/dashboard/update-show/${id}`,
    }}
    labels={{
      title: "TV shows",
      count: "shows in the catalogue",
      add: "Add Show",
      search: "Search tv show . . .",
      column: "TV Show",
      confirmDelete: "Are you sure you want to delete this show?",
    }}
  />
);

export default ShowList;
